import { z } from 'zod';
/**
 * BCP-47 language tags (ADR-014, spec 20 §4): a lowercase 2-3 letter primary
 * language subtag followed by optional 2-8 character subtags (`de`, `cs`,
 * `de-AT`). The database carries the same pattern as a CHECK.
 */
export const LANGUAGE_TAG_PATTERN = /^[a-z]{2,3}(-[A-Za-z0-9]{2,8})*$/;
/**
 * The canonical form of a BCP-47 tag (`de-at` -> `de-AT`), or `null` when the
 * value is not a well-formed tag (`deutsch`, `DE`, `de_AT`, `""`). Browser-safe:
 * API, worker and web share the same rule.
 */
export function parseLanguageTag(value) {
    if (typeof value !== 'string' || !LANGUAGE_TAG_PATTERN.test(value))
        return null;
    try {
        const [canonical] = Intl.getCanonicalLocales(value);
        return canonical !== undefined && LANGUAGE_TAG_PATTERN.test(canonical) ? canonical : null;
    }
    catch {
        return null;
    }
}
/** zod schema for a BCP-47 tag; parses to the canonical form. */
export const languageTagSchema = z.string().transform((value, context) => {
    const tag = parseLanguageTag(value);
    if (tag === null) {
        context.addIssue({ code: 'custom', message: 'invalid_language' });
        return z.NEVER;
    }
    return tag;
});
//# sourceMappingURL=language.js.map